import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-label fw-normal" }
const _hoisted_3 = { class: "d-flex gap-5 align-items-center" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_6 = { class: "title d-flex gap-4" }
const _hoisted_7 = { class: "d-flex align-items-center position-relative me-2" }
const _hoisted_8 = { class: "svg-icon svg-icon-3 position-absolute ms-3" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "toolbars" }
const _hoisted_11 = { class: "w-50px" }
const _hoisted_12 = { class: "w-150px" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_16 = {
  key: 1,
  class: "text-danger fw-bolder"
}
const _hoisted_17 = { class: "d-flex gap-4" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "text-primary fw-bold fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_DialogForms = _resolveComponent("DialogForms")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogListClubs,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogListClubs) = $event)),
      "close-on-click-modal": false,
      class: "dialog-custom rounded",
      fullscreen: true,
      onOpened: _ctx.onOpened,
      onClosed: _ctx.onClosed,
      "show-close": false
    }, {
      header: _withCtx(({ close, titleId }) => [
        _createElementVNode("div", {
          id: titleId,
          class: "d-flex align-items-start justify-content-between"
        }, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.itemForm?.form_name), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("i", {
              class: "bi bi-x-lg fs-1 cursor-pointer text-black text-hover-danger",
              onClick: close
            }, null, 8, _hoisted_4)
          ])
        ], 8, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                type: "text",
                class: "form-control form-control-white form-control-sm w-300px ps-9",
                placeholder: _ctx.t('search') + ' ' + _ctx.t('institution') + '...',
                maxlength: "100"
              }, null, 8, _hoisted_9), [
                [_vModelText, _ctx.search]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_button, {
              type: "primary",
              round: "",
              onClick: _ctx.getListInstitutions
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('update')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              color: "#00c1ae",
              round: "",
              class: "text-white",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.DownloadFile('xlsx', 'forms/f1', { a: _ctx.mbtoa(_ctx.itemForm.idevent) })))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('download')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.filteredClubs,
          ref: "singleTableRef",
          stripe: "",
          border: "",
          "header-cell-class-name": "text-black bg-secondary text-uppercase",
          class: "w-100 align-middle fs-7",
          style: {"width":"100%"},
          height: _ctx.altura - 300,
          "table-layout": 'auto',
          "highlight-current-row": "",
          "scrollbar-always-on": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              align: "center",
              "class-name": "border text-center align-middle fw-bold",
              width: "80"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_11, _toDisplayString(row.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "",
              prop: "abrev",
              label: _ctx.t('acronym'),
              align: "center",
              "class-name": "border text-center align-middle fw-bold",
              width: "150"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(row.abrev), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "business",
              label: _ctx.t('institution'),
              align: "left",
              "class-name": "border align-middle",
              width: "350"
            }, {
              default: _withCtx(({ row, $index }) => [
                _createElementVNode("div", {
                  class: "w-350px text-hover-primary cursor-pointer",
                  onClick: ($event: any) => (_ctx.openDialogForm(row.idinstitution, $index))
                }, _toDisplayString(row.business), 9, _hoisted_13)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('country'),
              align: "center",
              "class-name": "border align-middle fw-bold text-uppercase",
              width: "200"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_14, [
                  (row.country?.flag)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        style: {"width":"24px","height":"20px"},
                        src: `${_ctx.REPO}/${row.country?.flag}`,
                        fit: 'fill',
                        class: "rounded me-2"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(row.country?.name), 1)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "mstatus",
              label: _ctx.t('state'),
              align: "center",
              "class-name": "border text-center align-middle fw-bold"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(`badge badge-${row?.mstatus.params} text-white rounded px-2 py-1`),
                  style: {"font-size":"11px"}
                }, _toDisplayString(row?.mstatus?.name), 3)
              ]),
              _: 1
            }, 8, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSports, (sport, index) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: `isport-${index}-a`,
                label: sport.name,
                align: "center",
                "class-name": "border text-center align-middle fw-bold",
                "min-width": 150
              }, {
                default: _withCtx(({ row }) => [
                  (_ctx.isSelected(sport.idsport, row.sports))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "✓"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "X"))
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128)),
            _createVNode(_component_el_table_column, {
              label: "Total",
              align: "center",
              fixed: "right",
              "class-name": "border text-center align-middle fw-bold",
              "cell-style": { backgroundColor: '#000' }
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.calculateTotal(row.sports)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "OP",
              align: "center",
              fixed: "right",
              class: "d-flex"
            }, {
              default: _withCtx(({ row, $index }) => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("i", {
                    class: "i bi bi-pencil fs-2 cursor-pointer text-hover-primary",
                    onClick: ($event: any) => (_ctx.openDialogForm(row.idinstitution, $index))
                  }, null, 8, _hoisted_18),
                  _createElementVNode("i", {
                    class: "bi bi-trash fs-2 cursor-pointer text-hover-danger",
                    onClick: ($event: any) => (_ctx.handlerDeleteRecord(row))
                  }, null, 8, _hoisted_19)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "height"])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("span", _hoisted_20, "Total: " + _toDisplayString(_ctx.filteredClubs.length), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "onOpened", "onClosed"]),
    _createVNode(_component_DialogForms, {
      "list-status": _ctx.listStatus,
      "item-form": _ctx.itemForm,
      idevent: _ctx.itemForm.idevent,
      onModalClosed: _ctx.modalClosed
    }, null, 8, ["list-status", "item-form", "idevent", "onModalClosed"])
  ], 64))
}